import { useQuery } from '@tanstack/react-query';
import { IImageTemplateSlidePreview } from '../../../models/ImageTemplate';
import { useUserSession } from '../../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'admin/imageTemplates/<templateId>/preview';

export function useAdminImageTemplatePreviewQuery({
	enabled = true,
	lastModifiedDate,
	templateId,
	version,
}: {
	enabled?: boolean;
	lastModifiedDate?: string;
	templateId: string;
	version: number;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!templateId,
		queryFn: ({ signal }) =>
			userSession.webServiceHelper.callAsync<IImageTemplateSlidePreview[]>({
				path: `admin/imageTemplates/${encodeURIComponent(templateId)}/preview`,
				method: 'GET',
				signal,
			}),
		// Role edits change a draft without bumping its version, so the modified date is part of what was rendered.
		queryKey: [BASE_QUERY_KEY, templateId, version, lastModifiedDate],
		// A render costs 15-30s of server time and is deterministic for the same template state; never refetch it.
		refetchOnReconnect: false,
		refetchOnWindowFocus: false,
		retry: false,
		staleTime: Infinity,
		meta: {
			errorLogging: { fn: 'useAdminImageTemplatePreviewQuery' },
		},
	});
}
